import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useMultiStyleConfig} from '@chakra-ui/react'
import ProductTile from '../../../components/product-tile'
import {CompareProvider} from '../../../context/compare'
//import {useGigya} from '../../../context/gigya'
//import {setCustomData} from '../../../utils/gigya'

const SurveyResults = ({retrievedProducts}) => {
    const styles = useMultiStyleConfig('HelpMeChoose')

    //const {gigyaObject} = useGigya()
    //const {isLoaded, setIsLoaded} = useState(false)

    /* useEffect(() => {
        if (isLoaded || !gigyaObject) return
        gigyaObject.accounts.showScreenSet({
            screenSet: 'Default-LiteRegistration',
            startScreen: 'gigya-newsletter-screen',
            containerID: 'newsletter',
            deviceType: 'desktop',
            onBeforeScreenLoad: () => {},
            onAfterScreenLoad: () => {
                setIsLoaded(true)
            },
            onBeforeValidation: () => {},
            onSubmit: (e) => setCustomData(e),
            onAfterSubmit: () => {},
            onError: () => {},
            onFieldChanged: () => {},
        })
    }, [gigyaObject]) */

    return (
        <Flex {...styles.resultsInnerContainer} flexDirection="column">
            <CompareProvider>
                <Flex {...styles.retrievedProductsContainer}>
                    {retrievedProducts?.map((product, i) => {
                        return i < 3 ? (
                            <ProductTile
                                key={product.id}
                                data-testid={`survey-product-tile ${product.id}`}
                                enableFavourite
                                isFavourite={false}
                                product={product}
                                productIndex={i}
                                dynamicImageProps={styles?.retrievedProductsImageProps}
                                shouldHideCompare
                                shouldHideReviews
                                shouldHideVariants
                            />
                        ) : (
                            <></>
                        )
                    })}
                </Flex>
            </CompareProvider>
            {/* <div id="newsletter"></div> */}
        </Flex>
    )
}

SurveyResults.propTypes = {retrievedProducts: PropTypes.array}
export default SurveyResults
